import type { CookieKey } from "./types/cookieKey.types";
import type { GetCookieProps } from "./utils/getCookie";
import { getCookie } from "./utils/getCookie";
import type { SetCookieProps } from "./utils/setCookie";
import { setCookie } from "./utils/setCookie";

export const COOKIE_KEY_HOMEPAGE_VARIANT: CookieKey = "hlwHpVariant";

export type HomepageVariant = "control" | "jesus" | "content" | "excluded";

export type GetCookieHomepageVariantProps = Omit<GetCookieProps, "key">;

export const getCookieHomepageVariant = ({
  ...props
}: GetCookieHomepageVariantProps = {}) =>
  getCookie<HomepageVariant>({ key: COOKIE_KEY_HOMEPAGE_VARIANT, ...props });

export type SetCookieHomepageVariantProps = Omit<SetCookieProps, "key">;

export const setCookieHomepageVariant = ({
  ...props
}: SetCookieHomepageVariantProps) =>
  setCookie({ key: COOKIE_KEY_HOMEPAGE_VARIANT, ...props });
